module.exports = __webpack_public_path__ + "aeroland-section-call-to-action-03-bg.png?a7db7ea2cdf1da984823d5dc27b32d56";